// import React, { useState, useEffect } from "react";
// import { Code2, Smartphone, Cloud, Shield, Target, Rocket, Users, CheckCircle2, Zap, Award, Globe, TrendingUp } from "lucide-react";

// export default function CompanyPage() {
//   const [isVisible, setIsVisible] = useState(false);

//   useEffect(() => {
//     setIsVisible(true);
//   }, []);

//   const services = [
//     {
//       title: "Custom Software Development",
//       description:
//         "Tailored solutions built from the ground up to meet your specific business requirements and workflows.",
//       icon: Code2,
//     },
//     {
//       title: "Mobile App Development",
//       description:
//         "Native and cross-platform mobile applications that deliver seamless user experiences on iOS and Android.",
//       icon: Smartphone,
//     },
//     {
//       title: "Cloud Solutions",
//       description:
//         "Scalable cloud infrastructure and migration services to modernize your operations and reduce costs.",
//       icon: Cloud,
//     },
//     {
//       title: "Cybersecurity",
//       description:
//         "Comprehensive security solutions to protect your digital assets and ensure compliance with industry standards.",
//       icon: Shield,
//     },
//   ];

//   const expertise = [
//     "Enterprise Software Architecture",
//     "AI & Machine Learning Integration",
//     "DevOps & Continuous Integration",
//     "UI/UX Design & Prototyping",
//     "Data Analytics & Business Intelligence",
//     "API Development & Integration",
//   ];

//   return (
//     <div className="font-inter bg-white">
//       {/* Hero Section */}
//       <section className="relative h-80">
//         <img
//           src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=1600"
//           className="absolute inset-0 w-full h-full object-cover"
//         />
//         <div className="absolute inset-0 bg-gradient-to-r from-slate-900 via-slate-900/90 to-slate-900/80" />

//         <div
//           className={`relative h-full flex flex-col justify-center items-center text-center transition-all duration-700 ${
//             isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
//           }`}
//         >
//           <h1 className="text-5xl md:text-6xl font-bold mb-6 text-white">
//             Our Company
//           </h1>
//           <p className="text-xl text-slate-300 max-w-3xl mx-auto leading-relaxed">
//             Powering digital transformation through secure, scalable, and
//             intelligent software.
//           </p>
//         </div>
//       </section>

//       {/* Mission Section */}
//       <section className="py-20 bg-white">
//         <div className="max-w-6xl mx-auto px-6">
//           <div className="grid lg:grid-cols-2 gap-12 items-center">
//             <div className="order-2 lg:order-1">
//               <div className="relative">
//                 <div className="absolute -top-4 -left-4 w-24 h-24 bg-blue-100 rounded-full opacity-50"></div>
//                 <img
//                   src="https://images.unsplash.com/photo-1551434678-e076c223a692?w=800&h=600&fit=crop"
//                   alt="Mission"
//                   className="relative rounded-2xl shadow-2xl"
//                 />
//               </div>
//             </div>

//             <div className="order-1 lg:order-2">
//               <div className="inline-flex items-center gap-2 bg-blue-50 px-4 py-2 rounded-full mb-6">
//                 <Target className="w-5 h-5 text-blue-600" />
//                 <span className="text-sm font-semibold text-blue-700">
//                   Our Mission
//                 </span>
//               </div>

//               <h2 className="text-4xl font-bold text-slate-900 mb-6">
//                 Empowering Businesses Through Innovation
//               </h2>

//               <p className="text-lg text-slate-600 mb-6 leading-relaxed">
//                 Our mission is to empower businesses of all sizes with
//                 cutting-edge software solutions that drive growth, enhance
//                 efficiency, and enable digital transformation. We are committed
//                 to delivering excellence through innovation, collaboration, and
//                 a deep understanding of our clients' unique challenges.
//               </p>

//               <p className="text-lg text-slate-600 mb-8 leading-relaxed">
//                 We believe that technology should be a catalyst for positive
//                 change, enabling organizations to reach their full potential and
//                 create lasting value for their stakeholders.
//               </p>

//               <div className="grid grid-cols-2 gap-4">
//                 <div className="flex items-start gap-3">
//                   <CheckCircle2 className="w-6 h-6 text-blue-600 flex-shrink-0 mt-1" />
//                   <div>
//                     <h4 className="font-semibold text-slate-900 mb-1">
//                       Client Success
//                     </h4>
//                     <p className="text-sm text-slate-600">
//                       Your success is our priority
//                     </p>
//                   </div>
//                 </div>
//                 <div className="flex items-start gap-3">
//                   <Zap className="w-6 h-6 text-blue-600 flex-shrink-0 mt-1" />
//                   <div>
//                     <h4 className="font-semibold text-slate-900 mb-1">
//                       Innovation First
//                     </h4>
//                     <p className="text-sm text-slate-600">
//                       Leading-edge solutions
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Vision Section */}
//       <section className="py-20 bg-gradient-to-br from-purple-50 via-blue-50 to-indigo-50">
//         <div className="max-w-6xl mx-auto px-6">
//           <div className="grid lg:grid-cols-2 gap-12 items-center">
//             <div>
//               <div className="inline-flex items-center gap-2 bg-purple-100 px-4 py-2 rounded-full mb-6">
//                 <Rocket className="w-5 h-5 text-purple-600" />
//                 <span className="text-sm font-semibold text-purple-700">
//                   Our Vision
//                 </span>
//               </div>

//               <h2 className="text-4xl font-bold text-slate-900 mb-6">
//                 Shaping the Future of Technology
//               </h2>

//               <p className="text-lg text-slate-600 mb-6 leading-relaxed">
//                 We envision a world where every business, regardless of size or
//                 industry, has access to world-class software solutions that
//                 enable them to compete and thrive in the digital economy. Our
//                 vision is to become a globally recognized technology partner,
//                 known for our innovative approach, technical excellence, and
//                 unwavering commitment to client success.
//               </p>

//               <p className="text-lg text-slate-600 mb-8 leading-relaxed">
//                 By 2030, we aim to be at the forefront of emerging technologies,
//                 helping organizations navigate the complexities of AI, cloud
//                 computing, and digital transformation with confidence and
//                 clarity.
//               </p>

//               <div className="space-y-4">
//                 <div className="flex items-center gap-3 bg-white p-4 rounded-lg shadow-sm">
//                   <Globe className="w-8 h-8 text-purple-600" />
//                   <div>
//                     <h4 className="font-semibold text-slate-900">
//                       Global Reach
//                     </h4>
//                     <p className="text-sm text-slate-600">
//                       Serving clients across continents
//                     </p>
//                   </div>
//                 </div>
//                 <div className="flex items-center gap-3 bg-white p-4 rounded-lg shadow-sm">
//                   <Award className="w-8 h-8 text-purple-600" />
//                   <div>
//                     <h4 className="font-semibold text-slate-900">
//                       Industry Leadership
//                     </h4>
//                     <p className="text-sm text-slate-600">
//                       Setting standards in software excellence
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="relative">
//               <div className="absolute -bottom-4 -right-4 w-24 h-24 bg-purple-100 rounded-full opacity-50"></div>
//               <img
//                 src="https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&h=600&fit=crop"
//                 alt="Vision"
//                 className="relative rounded-2xl shadow-2xl"
//               />
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Culture Section */}
//       <section className="py-20 bg-white">
//         <div className="max-w-6xl mx-auto px-6">
//           <div className="text-center mb-16">
//             <div className="inline-flex items-center gap-2 bg-green-50 px-4 py-2 rounded-full mb-6">
//               <Users className="w-5 h-5 text-green-600" />
//               <span className="text-sm font-semibold text-green-700">
//                 Our Culture
//               </span>
//             </div>

//             <h2 className="text-4xl font-bold text-slate-900 mb-6">
//               Where Innovation Meets Collaboration
//             </h2>

//             <p className="text-lg text-slate-600 max-w-3xl mx-auto leading-relaxed">
//               At Infronex, we've cultivated a culture that celebrates
//               creativity, encourages continuous learning, and values every team
//               member's contribution. We believe that great software is built by
//               great teams working in an environment of trust, respect, and
//               shared purpose.
//             </p>
//           </div>

//           <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
//             {[
//               {
//                 title: "Innovation",
//                 description:
//                   "We embrace new ideas and technologies, constantly pushing boundaries to deliver cutting-edge solutions.",
//                 icon: Zap,
//                 color: "text-yellow-600",
//                 bg: "bg-yellow-50",
//               },
//               {
//                 title: "Collaboration",
//                 description:
//                   "Teamwork is at our core. We believe the best results come from diverse perspectives working together.",
//                 icon: Users,
//                 color: "text-blue-600",
//                 bg: "bg-blue-50",
//               },
//               {
//                 title: "Excellence",
//                 description:
//                   "We set high standards and take pride in delivering quality work that exceeds expectations.",
//                 icon: Award,
//                 color: "text-purple-600",
//                 bg: "bg-purple-50",
//               },
//               {
//                 title: "Growth",
//                 description:
//                   "We invest in our people's development, providing opportunities to learn, grow, and advance their careers.",
//                 icon: TrendingUp,
//                 color: "text-green-600",
//                 bg: "bg-green-50",
//               },
//             ].map((value, index) => {
//               const Icon = value.icon;
//               return (
//                 <div
//                   key={index}
//                   className="bg-white border-2 border-slate-100 rounded-xl p-6 hover:border-slate-200 hover:shadow-lg transition-all"
//                 >
//                   <div
//                     className={`w-12 h-12 ${value.bg} rounded-lg flex items-center justify-center mb-4`}
//                   >
//                     <Icon className={`w-6 h-6 ${value.color}`} />
//                   </div>
//                   <h3 className="text-xl font-semibold text-slate-900 mb-2">
//                     {value.title}
//                   </h3>
//                   <p className="text-slate-600 text-sm leading-relaxed">
//                     {value.description}
//                   </p>
//                 </div>
//               );
//             })}
//           </div>

//           <div className="bg-gradient-to-r from-green-50 to-emerald-50 rounded-2xl p-8 border border-green-100">
//             <h3 className="text-2xl font-semibold text-slate-900 mb-6 text-center">
//               What Makes Us Different
//             </h3>
//             <div className="grid md:grid-cols-3 gap-6">
//               {[
//                 "Flexible work environment that promotes work-life balance",
//                 "Continuous learning programs and professional development",
//                 "Open communication and transparent leadership",
//                 "Recognition and rewards for outstanding contributions",
//                 "Diverse and inclusive workplace culture",
//                 "Opportunity to work on challenging, impactful projects",
//               ].map((item, i) => (
//                 <div key={i} className="flex items-start gap-3">
//                   <CheckCircle2 className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" />
//                   <p className="text-slate-700 text-sm">{item}</p>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Services */}
//       <section className="py-20 bg-slate-50">
//         <div className="max-w-7xl mx-auto px-6">
//           <div className="text-center mb-12">
//             <h2 className="text-4xl font-bold text-slate-900 mb-4">
//               What We Do
//             </h2>
//             <p className="text-lg text-slate-600 max-w-2xl mx-auto">
//               Comprehensive software solutions tailored to your business needs
//             </p>
//           </div>

//           <div className="grid md:grid-cols-2 gap-6 mb-12">
//             {services.map((service, index) => {
//               const Icon = service.icon;
//               return (
//                 <div
//                   key={index}
//                   className="bg-white border border-slate-200 rounded-xl p-8 hover:shadow-xl hover:border-slate-300 transition-all"
//                 >
//                   <div className="w-14 h-14 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-lg flex items-center justify-center mb-4">
//                     <Icon className="w-7 h-7 text-white" />
//                   </div>
//                   <h3 className="text-xl font-semibold text-slate-900 mb-3">
//                     {service.title}
//                   </h3>
//                   <p className="text-slate-600 leading-relaxed">
//                     {service.description}
//                   </p>
//                 </div>
//               );
//             })}
//           </div>

//           {/* Expertise */}
//           <div className="bg-gradient-to-r from-slate-800 to-slate-900 rounded-2xl p-10 text-white">
//             <h3 className="text-3xl font-bold text-center mb-8">
//               Our Technical Expertise
//             </h3>

//             <div className="grid md:grid-cols-3 gap-4">
//               {expertise.map((item, index) => (
//                 <div
//                   key={index}
//                   className="bg-white/10 backdrop-blur-sm rounded-lg px-5 py-4 text-sm font-medium hover:bg-white/20 transition-colors"
//                 >
//                   <CheckCircle2 className="w-4 h-4 inline-block mr-2 text-green-400" />
//                   {item}
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* CTA */}
//       <section className="py-20 bg-gradient-to-r from-purple-600 via-indigo-600 to-blue-600">
//         <div className="max-w-4xl mx-auto px-6 text-center">
//           <h2 className="text-4xl font-bold text-white mb-4">
//             Ready to Transform Your Business?
//           </h2>

//           <p className="text-lg text-purple-100 mb-8 max-w-2xl mx-auto">
//             Partner with Infronex to create innovative, scalable digital
//             solutions that drive real results.
//           </p>

//           <div className="flex justify-center gap-3 flex-wrap">
//             <a
//               href="/contact"
//               className="px-5 py-2.5 bg-white text-purple-600 text-sm font-semibold rounded-md hover:bg-purple-50 transition hover:shadow-md"
//             >
//               Start Your Project →
//             </a>

//             <a
//               href="/services"
//               className="px-5 py-2.5 bg-purple-700/50 backdrop-blur-sm border border-white/30 text-white text-sm font-semibold rounded-md hover:bg-purple-700 transition"
//             >
//               Explore Services
//             </a>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// }

import React, { useState, useEffect } from "react";
import {
  Code2,
  Smartphone,
  Cloud,
  Shield,
  Target,
  Rocket,
  Users,
  CheckCircle2,
  Zap,
  Award,
  Globe,
  TrendingUp,
  ChevronRight,
  Fingerprint,
} from "lucide-react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

export default function CompanyPage() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const services = [
    {
      title: "Custom Software Engineering",
      description:
        "High-performance, scalable architectures engineered to solve complex enterprise challenges.",
      icon: Code2,
    },
    {
      title: "Mobile Ecosystems",
      description:
        "Seamless native and hybrid applications designed for high user engagement and retention.",
      icon: Smartphone,
    },
    {
      title: "Cloud Infrastructure",
      description:
        "Strategic cloud migration and serverless architectures optimized for security and cost.",
      icon: Cloud,
    },
    {
      title: "Cyber Resilience",
      description:
        "Advanced security protocols and compliance frameworks to protect critical digital assets.",
      icon: Shield,
    },
  ];

  const expertise = [
    "Enterprise Software Architecture",
    "AI & Machine Learning Integration",
    "DevOps & CI/CD Pipelines",
    "UI/UX Design Systems",
    "Data Analytics & BI",
    "Scalable API Ecosystems",
  ];

  const fadeUp = {
    initial: { opacity: 0, y: 20 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true },
    transition: { duration: 0.6 },
  };

  return (
    <div className="bg-white selection:bg-indigo-100">
      {/* ========== REFINED HERO SECTION ========== */}
      <section className="relative h-[450px] flex items-center overflow-hidden">
        <img
          src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=1600"
          className="absolute inset-0 w-full h-full object-cover grayscale-[40%]"
          alt="Company Hero"
        />
        <div className="absolute inset-0 bg-slate-950/80 backdrop-blur-[2px]" />

        {/* Subtle Tech Grid */}
        <div
          className="absolute inset-0 opacity-[0.1]"
          style={{
            backgroundImage: `radial-gradient(#4f46e5 0.5px, transparent 0.5px)`,
            backgroundSize: "30px 30px",
          }}
        />

        <div className="max-w-7xl mx-auto px-6 relative z-10 w-full">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="max-w-3xl"
          >
            <span className="inline-block text-indigo-400 text-[11px] font-bold tracking-[0.4em] uppercase mb-4">
              Corporate Overview
            </span>
            <h1 className="text-5xl md:text-7xl font-extrabold text-white mb-6 tracking-tight leading-[1.1]">
              Architecting the <span className="text-slate-500">Next.</span>
            </h1>
            <p className="text-lg md:text-xl text-slate-400 text-white font-light leading-relaxed">
              Infronex delivers enterprise-grade software solutions that empower
              organizations to navigate digital complexity with absolute
              confidence.
            </p>
          </motion.div>
        </div>
      </section>

      {/* ========== MISSION: DYNAMIC SPLIT ========== */}
      <section className="py-32 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-20 items-center">
            <motion.div {...fadeUp} className="relative">
              <div className="aspect-square rounded-3xl overflow-hidden shadow-2xl">
                <img
                  src="https://images.unsplash.com/photo-1551434678-e076c223a692?w=800&fit=crop"
                  alt="Mission"
                  className="w-full h-full object-cover"
                />
              </div>
              {/* Floating Performance Stat */}
              <div className="absolute -bottom-10 -right-10 bg-slate-900 text-white p-8 rounded-2xl shadow-2xl hidden xl:block">
                <div className="text-3xl font-bold text-indigo-400 mb-1">
                  99.9%
                </div>
                <div className="text-[10px] uppercase tracking-widest opacity-60">
                  Service Integrity
                </div>
              </div>
            </motion.div>

            <motion.div {...fadeUp} transition={{ delay: 0.2 }}>
              <div className="flex items-center gap-3 mb-6">
                <div className="w-10 h-px bg-indigo-600" />
                <span className="text-xs font-bold text-indigo-600 uppercase tracking-widest">
                  Our Mission
                </span>
              </div>
              <h2 className="text-4xl font-bold text-slate-900 mb-6 leading-tight">
                Empowering Business Through Engineering Excellence.
              </h2>
              <p className="text-slate-600 mb-8 leading-relaxed">
                We bridge the gap between abstract business goals and robust
                technical execution. Our engineering teams prioritize
                scalability and security at every line of code.
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 pt-6 border-t border-slate-100">
                <div className="flex items-start gap-3">
                  <Fingerprint className="w-5 h-5 text-indigo-600 mt-1" />
                  <div>
                    <h4 className="font-bold text-slate-900 text-sm">
                      Strategic Identity
                    </h4>
                    <p className="text-xs text-slate-500 mt-1">
                      Tailored logic for unique workflows.
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <Zap className="w-5 h-5 text-indigo-600 mt-1" />
                  <div>
                    <h4 className="font-bold text-slate-900 text-sm">
                      Agile Execution
                    </h4>
                    <p className="text-xs text-slate-500 mt-1">
                      Rapid, iterative delivery cycles.
                    </p>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* ========== VISION: MINIMALIST DARK ========== */}
      <section className="py-24 bg-slate-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <motion.div {...fadeUp}>
              <div className="flex items-center gap-3 mb-6">
                <div className="w-10 h-px bg-indigo-600" />
                <span className="text-xs font-bold text-indigo-600 uppercase tracking-widest">
                  Vision 2030
                </span>
              </div>
              <h2 className="text-3xl font-bold text-slate-900 mb-8">
                Shaping the Global Digital Standards.
              </h2>
              <div className="space-y-4">
                {[
                  {
                    icon: Globe,
                    label: "Global Presence",
                    sub: "Collaborating across 4 continents.",
                  },
                  {
                    icon: Award,
                    label: "Industry Benchmarks",
                    sub: "Defining quality in modern SaaS.",
                  },
                ].map((item, i) => (
                  <div
                    key={i}
                    className="flex items-center gap-4 bg-white p-5 rounded-xl border border-slate-200 group hover:border-indigo-500/30 transition-all"
                  >
                    <div className="w-12 h-12 bg-slate-50 flex items-center justify-center rounded-lg text-slate-900 group-hover:bg-indigo-600 group-hover:text-white transition-all">
                      <item.icon size={22} />
                    </div>
                    <div>
                      <h4 className="font-bold text-slate-900 text-sm">
                        {item.label}
                      </h4>
                      <p className="text-xs text-slate-500">{item.sub}</p>
                    </div>
                  </div>
                ))}
              </div>
            </motion.div>
            <motion.div {...fadeUp} transition={{ delay: 0.3 }}>
              <img
                src="https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&fit=crop"
                alt="Strategic Vision"
                className="rounded-3xl shadow-2xl grayscale-[20%]"
              />
            </motion.div>
          </div>
        </div>
      </section>

      {/* ========== SERVICES: ARCHITECTURAL CARDS ========== */}
      <section className="py-32 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-20">
            <h2 className="text-4xl font-bold text-slate-900 mb-4">
              Service Capabilities
            </h2>
            <p className="text-slate-500 max-w-xl mx-auto">
              Comprehensive expertise across the digital product lifecycle.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
            {services.map((service, index) => (
              <motion.div
                key={index}
                {...fadeUp}
                transition={{ delay: index * 0.1 }}
                className="group bg-white border border-slate-200 p-8 rounded-2xl hover:shadow-2xl hover:shadow-indigo-500/5 hover:-translate-y-1 transition-all"
              >
                <div className="w-12 h-12 bg-slate-50 flex items-center justify-center rounded-xl text-slate-900 mb-6 group-hover:bg-indigo-600 group-hover:text-white transition-all">
                  <service.icon size={24} />
                </div>
                <h3 className="text-lg font-bold text-slate-900 mb-3 group-hover:text-indigo-600 transition-colors">
                  {service.title}
                </h3>
                <p className="text-[13px] text-slate-500 leading-relaxed font-light">
                  {service.description}
                </p>
              </motion.div>
            ))}
          </div>

          {/* Technical Expertise Badge Area */}
          <div className="bg-slate-950 rounded-3xl p-10 relative overflow-hidden">
            <div className="absolute top-0 right-0 w-64 h-64 bg-indigo-600/10 blur-[100px] rounded-full" />
            <h3 className="text-2xl font-bold text-white text-center mb-10 relative z-10">
              Technical Domain Expertise
            </h3>
            <div className="grid md:grid-cols-3 gap-3 relative z-10">
              {expertise.map((item, i) => (
                <div
                  key={i}
                  className="bg-white/5 border border-white/10 backdrop-blur-md rounded-xl p-4 flex items-center gap-3 group hover:bg-white/10 transition-all"
                >
                  <CheckCircle2 size={16} className="text-indigo-400" />
                  <span className="text-[13px] text-slate-300 font-medium tracking-wide">
                    {item}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ========== CTA: CLEAN & BOLD ========== */}
      <section className="py-24 bg-slate-950 relative overflow-hidden">
        <div className="absolute bottom-0 left-0 right-0 h-1/2 bg-gradient-to-t from-indigo-900/20 to-transparent" />
        <div className="max-w-4xl mx-auto px-6 text-center relative z-10">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6">
            Ready to initiate your transformation?
          </h2>
          <p className="text-slate-400 text-lg mb-10 max-w-xl mx-auto font-light leading-relaxed">
            Partner with Infronex to build high-performance software that drives
            business outcomes.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Link
              to="/contact"
              className="bg-white text-slate-950 px-8 py-3.5 rounded-xl text-sm font-bold hover:bg-indigo-50 transition-all shadow-xl"
            >
              Initiate Consultation
            </Link>
            {/* <a
              href="/services"
              className="border border-slate-700 text-slate-300 px-8 py-3.5 rounded-xl text-sm font-bold hover:bg-slate-800 transition-all"
            >
              View Capabilities
            </a> */}
          </div>
        </div>
      </section>
    </div>
  );
}